/** Rango del slider de offset fino (segundos); debe coincidir con el UI. */
export const FINE_OFFSET_MIN = -60;
export const FINE_OFFSET_MAX = 60;

export function clampFineOffsetSeconds(v: number): number {
  return Math.min(FINE_OFFSET_MAX, Math.max(FINE_OFFSET_MIN, v));
}

/** Coma o punto como decimal (es-ES). */
export function parseFineOffsetInput(raw: string): number | null {
  const s = raw.trim().replace(',', '.');
  if (s === '' || s === '-' || s === '+') return null;
  const v = parseFloat(s);
  return Number.isFinite(v) ? v : null;
}
